<template>
  <v-flex
    v-if="!loading"
    xs8
    offset-xs2
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.created_at="{ item }">
            {{ item.created_at | timeFormat }}
      </template>
      <template v-slot:item.actions="{ item }">
            <v-layout row wrap>
              <v-flex>
              </v-flex>
            </v-layout>
      </template>
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchMoviments"
    />
  </div>
  </v-flex>
  <Loader v-else/>
</template>
<script>

  import { mapActions } from 'vuex';

  import { warehousesService } from '../../utils/services/warehouses.service';
  import Search from '../../components/shared/Inputs/Search';
  import Loader from '../../components/shared/Loader';
  import Paginator from '../../components/shared/Paginator';

  export default {
    name: 'WarehouseLoadList',
    components: { Search, Loader, Paginator },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['created_at'],
        },
        headers: [
          {
            text: this.$t('fields.id'),
            align: 'left',
            value: 'id',
          },
          { text: this.$t('fields.sku'), value: 'options.sku' },
          { text: this.$t('fields.name'), value: 'options.name' },
          { text: this.$t('fields.quantity'), value: 'options.qty' },
          { text: this.$t('fields.from'), value: 'options.warehouse' },
          { text: this.$t('fields.to'), value: 'options.warehouse_to' },
          { text: this.$t('fields.created_at'), value: 'created_at' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
        filters: {
          search: null,
          movimentType: 'transfer',
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          search: this.filters.search,
          movimentType: this.filters.movimentType,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      async fetchMoviments(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return warehousesService.moviments({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      await this.fetchMoviments(this.pagination.page);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchMoviments(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchMoviments(1);
          }
        },
      },

    },
  };
</script>
